import React, { useState, useEffect } from 'react'

import callApi from '../../util/callApi';
import moment from 'moment';
import { BoxActionComment } from '../boxComment/boxActionComment'
import { LIMIT_SUBCOMMENT_ITEM } from '../../config/config'
import { BoxInputComment } from '../boxComment/boxInputComment'
import Viewer from 'react-viewer'
import mathJaxUtil from '../../util/mathjaxUtil'
export const SubComment = (props) => {

    const {totalSubComment} = props;
    
    const [pageSub, setPage] = useState(1);
    const [totalComment, setTotalComment] = useState(totalSubComment);

    const [subComments, setSubComment] = useState([]);
    const [current_image_view, setCurrentImageView] = useState('');
    const [visibleViwer, setVisibleViwer] = useState(false);
    

    const callApiSubcomment = async (page, limit = LIMIT_SUBCOMMENT_ITEM) => {
        var data = {
            root_comment_id: props.rootCommentId,
            current_page: page,
            limit: limit
        }
        const getSubComment = await callApi('v1/user_comment/subComment', 'get', data);
        if (getSubComment && getSubComment.status == 1) {
            setSubComment([ ...subComments, ...(getSubComment.data || [])] )
        }
    }


    const loadmoreComment = async (page) => {
        props.pingMathjax();
        setPage(page);
        callApiSubcomment(page);
    }

    const pushSubCmt = (new_sub_cmt) => {
        const new_sub = [new_sub_cmt];
        setSubComment([...subComments, ...new_sub]);
        setTotalComment(totalComment + 1)
    }

    useEffect(() => {
        if (props.totalSubComment > 0) {
            callApiSubcomment();
        }
    }, []);

    const setCurrentView = (src) => {
        setVisibleViwer(true);
        setCurrentImageView(src);
    }

    const hiddenViewer = (e) => {
        if (e) {
            setVisibleViwer(false);
        }
    }

    return (
        <div id="sub-cmt-mathjax" className={subComments.length > 0 ? "cardBg boxRep boxSubComment" : ""}>
            <Viewer
                width={100}
                height={100}
                defaultScale={1.25}
                onMaskClick={hiddenViewer}
                visible={visibleViwer}
                scalable={false} zoomSpeed={0.25} activeIndex={0} noNavbar={true} noImgDetails={true} changeable={true} noResetZoomAfterChange={true}
                onClose={() => setVisibleViwer(false)}
                visible={visibleViwer}
                onClose={() => setVisibleViwer(false)}
                images={[{ src: current_image_view, alt: '' }]}
            />
            {!(totalComment > 0 && subComments.length == 0) ? (
                
                <>
                    {subComments.map((subComment, index) =>
                        <div className="userBlock" key={index+subComment._id} sub-cmt-id={subComment._id}>
                            <img src={subComment.avatar} alt="" className="avatar" />
                            <div className="userInfo">
                                <div className="usernameAndDate">
                                    <span className={subComment.is_mod > 0 ? "username bold isTeacher" : "username bold"}>{subComment.fullname}:</span>
                                    <span className="dateTime"> {moment.unix(subComment.create_time).format('HH:mm DD/MM/YYYY')}</span>
                                </div>
                                <div className="content">
                                    <div dangerouslySetInnerHTML={{ __html: subComment.html_content }} />
                                    {
                                        subComment.images && subComment.images.length > 0 ?
                                            <div className={"cardBg questionImg" + (subComment.images.length > 1?" mutilImg": "") } >
                                                {subComment.images.map(function (img, index_child_img) {
                                                    return (
                                                        <a key={index_child_img} style={{ cursor: "pointer" }} onClick={(e) => setCurrentView(img)}><img src={img} alt="" /></a>
                                                    )
                                                })} </div> : ''
                                    } 
                                </div>
                                <BoxActionComment rootAuthorId={props.rootAuthorId} user_id={props.user_id} comment_type={true} data_comment={subComment} />
                            </div>
                        </div>
                    )}
                    {/* Load more */}

                    {totalSubComment > (pageSub * LIMIT_SUBCOMMENT_ITEM) ? (
                        <div className="btnLoadmore subComment">
                            <button onClick={() => loadmoreComment(pageSub + 1)} > Xem thêm trả lời</button>
                        </div>
                    ) : (<></>)}

                </>
            ) : (<></>)}


            {/* Box tra loi */}
            {
                props.show_answer_id == props.rootCommentId ? 
                    <BoxInputComment item_type={props.item_type} item_id={props.item_id} item_action={props.item_action} pushCmt={pushSubCmt} avatar={props.avatar} comment_id={props.rootCommentId} is_mod_hoidap={props.is_mod_hoidap} content="" /> : ''
            }
        </div>
    )

}